"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsyncValue = void 0;
const react_1 = require("react");
const use_async_call_1 = require("./use-async-call");
const rxjs_1 = require("rxjs");
const useAsyncValue = (fetchValue, volatileArgs) => {
    const [value, setValue] = react_1.useState(null);
    const [pending, setPending] = react_1.useState(null);
    const [promise, setPromise] = react_1.useState(null);
    const [fetch, fetching, error] = use_async_call_1.useAsyncCall(() => __awaiter(void 0, void 0, void 0, function* () {
        if (pending) {
            pending.unsubscribe();
        }
        const promise = fetchValue();
        setPromise(promise);
        const subscription = rxjs_1.from(promise).subscribe({
            next: value => setValue(value),
            error: () => subscription.unsubscribe()
        });
        setPending(subscription);
        yield promise;
    }));
    react_1.useEffect(() => {
        fetch();
    }, volatileArgs || []);
    const loading = fetching || pending === null;
    return [value, loading, error, promise];
};
exports.useAsyncValue = useAsyncValue;
//# sourceMappingURL=use-async-value.js.map